import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { CompactWorkshopCard } from "@/components/CompactWorkshopCard";
import { Skeleton } from "@/components/ui/skeleton";
import { Navigation } from "lucide-react";

const fmtKm = (km) => (km < 1 ? "a menos de 1 km" : `a ${String(km).replace(".", ",")} km`);

export function NearbyWorkshops({ commune, region, level, maxPrice, keep, cardProps }) {
  const [list, setList] = useState(null);
  useEffect(() => {
    setList(null);
    const params = { commune, region };
    if (level !== "all") params.level = level;
    if (maxPrice) params.max_price = maxPrice;
    api.get("/geo/nearby", { params }).then((r) => setList(r.data)).catch(() => setList([]));
  }, [commune, region, level, maxPrice]);

  if (list === null) {
    return <div className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 mt-6">{[...Array(4)].map((_, i) => <Skeleton key={i} className="h-56 rounded-xl" />)}</div>;
  }
  const items = list.filter(keep);
  if (!items.length) return null;
  return (
    <div className="mt-8 text-left animate-in fade-in slide-in-from-bottom-2 duration-500" data-testid="nearby-section">
      <h3 className="mb-1 text-base md:text-lg font-bold text-foreground flex items-center gap-2">
        <Navigation className="w-5 h-5 text-primary" />Talleres cerca de {commune}
      </h3>
      <p className="mb-4 text-sm text-muted-foreground">Ordenados por distancia desde {commune}.</p>
      <div className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4" data-testid="nearby-grid">
        {items.map((w) => (
          <div key={w.id} className="relative" data-testid={`nearby-${w.id}`}>
            <span className="absolute top-2 right-2 z-10 inline-flex items-center gap-1 rounded-full bg-background/90 backdrop-blur px-2 py-0.5 text-[11px] font-semibold text-primary shadow-sm" data-testid={`nearby-distance-${w.id}`}>
              <Navigation className="w-3 h-3" />{fmtKm(w.distance_km)}
            </span>
            <CompactWorkshopCard workshop={w} {...cardProps(w)} />
          </div>
        ))}
      </div>
    </div>
  );
}
